import { Box, Heading, ModalBody, Text } from '@bechtel/gds';
import { UiTextEnum } from '@bechtel/sr-types';
import { Formik } from 'formik';
import { FC } from 'react';
import { object, string } from 'yup';
import { MultiLingualText, useLanguage } from '~/components';
import { FooterButtonStyled, ModalFooterStyled, ModalHeaderStyled, ModalStyled, TextAreaStyled } from './styled';

export interface AddChangeManagementNotesModalProps {
  onSubmit: (note: string) => Promise<void>;
}

interface FormikAddNoteState {
  note: string;
}

const initialValues: FormikAddNoteState = {
  note: '',
};

const validationSchema = object().shape({
  note: string()
    .trim()
    .min(1, `Please enter atleast one character for note`)
    .max(255, `Please limit name to 255 characters`)
    .required(`Note is mandatory`),
});

export const AddChangeManagementNoteModal: FC<AddChangeManagementNotesModalProps> = ({ onSubmit }) => {
  const { getMultiLingualTextByKey } = useLanguage();

  return (
    <ModalStyled visible={true}>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize={true}
        onSubmit={(values) => {
          onSubmit(values ? values.note : '');
        }}
      >
        {({ values, handleChange, handleBlur, handleSubmit, dirty, isValid, touched }) => {
          return (
            <>
              <ModalHeaderStyled title="">
                <Box pl={{ sm: '300' }}>
                  <Heading size="500" weight="500">
                    <MultiLingualText>Change Management Notes</MultiLingualText>
                  </Heading>
                </Box>
              </ModalHeaderStyled>
              {/* @ts-ignore adjust in GDS component to take child as prop  */}
              <ModalBody
                css={`
                  flex-direction: column;
                `}
              >
                <form style={{ width: '100%' }}>
                  <Box flexDirection={{ sm: 'column' }} pt={{ sm: '450' }} px={{ sm: '400' }}>
                    <Box mb={{ sm: '200' }}>
                      <MultiLingualText size="300" color="grey.900">
                        Reason for the return
                      </MultiLingualText>
                      <Text color="red.500">*</Text>
                    </Box>
                    <TextAreaStyled
                      name="note"
                      onChange={handleChange}
                      value={values.note}
                      placeholder={getMultiLingualTextByKey(UiTextEnum.ENTER_COMMENTS)}
                      rows={7}
                      onBlur={handleBlur}
                      changed={dirty}
                    />
                  </Box>
                </form>
              </ModalBody>
              <ModalFooterStyled>
                <Box p={{ sm: '500' }}>
                  <FooterButtonStyled onClick={() => handleSubmit()} disabled={!dirty || !isValid || !touched}>
                    <Box px={{ sm: '500' }}>
                      <MultiLingualText>Save</MultiLingualText>
                    </Box>
                  </FooterButtonStyled>
                </Box>
              </ModalFooterStyled>
            </>
          );
        }}
      </Formik>
    </ModalStyled>
  );
};
